/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
export default function _customTabGroup() {
    const TAB_GROUP_SELECTOR = '.tabs-rsev';
    const TAB_CONTENT_ACTIVE_CLASS = 'tab__content-rsev--active';
    const TAB_BUTTON_ACTIVE_CLASS = 'active';

    function isSmallerDevice() {
        return window.innerWidth < 430;
    }

    function isOverflowing(element) {
        return element.scrollWidth > element.clientWidth;
    }

    function checkBorder(tabListNav, TAB_CONTENTS, TAB_BUTTONS) {
        const tabsScrollLocation = tabListNav.scrollLeft;

        if (tabsScrollLocation > 0) {
            tabListNav.style.borderRight = 'none';
        } else if (isSmallerDevice() && isOverflowing(tabListNav)) {
            tabListNav.style.borderRight = '1px solid #d3d3d3';
        } else if (!isOverflowing(tabListNav)) {
            TAB_CONTENTS.forEach((tabContentContainer) => {
                tabContentContainer.style.borderTopRightRadius = '15px';
            });
            TAB_BUTTONS.forEach((button) => {
                button.style.cursor = 'initial';
            });
        } else if (isOverflowing(tabListNav)) {
            TAB_CONTENTS.forEach((tabContentContainer) => {
                tabContentContainer.style.borderTopRightRadius = '0';
            });
        }
    }

    function addHorizontalScroll(tabs, tabListNav, TAB_CONTENTS, TAB_BUTTONS) {
        let isDown = false;
        let startX;
        let scrollLeft;

        function handleMouseDown(e) {
            isDown = true;
            tabs.classList.add('scrolling');
            startX = e.pageX - tabs.offsetLeft;
            scrollLeft = tabs.scrollLeft;
        }

        function handleMouseLeave() {
            isDown = false;
            tabs.classList.remove('scrolling');
        }

        function handleMouseUp() {
            isDown = false;
            tabs.classList.remove('scrolling');
            if (isSmallerDevice()) {
                checkBorder(tabListNav, TAB_CONTENTS, TAB_BUTTONS);
            }
        }

        function handleMouseMove(e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - tabs.offsetLeft;
            const walk = (x - startX) * 3;
            tabs.scrollLeft = scrollLeft - walk;
            if (isSmallerDevice()) {
                checkBorder(tabListNav, TAB_CONTENTS, TAB_BUTTONS);
            }
        }

        function handleTouchStart(e) {
            isDown = true;
            startX = e.touches[0].pageX - tabs.offsetLeft;
            scrollLeft = tabs.scrollLeft;
        }

        function handleTouchEnd() {
            isDown = false;
            if (isSmallerDevice()) {
                checkBorder(tabListNav, TAB_CONTENTS, TAB_BUTTONS);
            }
        }

        function handleTouchMove(e) {
            if (!isDown) return;
            const x = e.touches[0].pageX - tabs.offsetLeft;
            const walk = (x - startX) * 3;
            tabs.scrollLeft = scrollLeft - walk;
            if (isSmallerDevice()) {
                checkBorder(tabListNav, TAB_CONTENTS, TAB_BUTTONS);
            }
        }

        tabs.addEventListener('mousedown', handleMouseDown);
        tabs.addEventListener('mouseleave', handleMouseLeave);
        tabs.addEventListener('mouseup', handleMouseUp);
        tabs.addEventListener('mousemove', handleMouseMove);
        tabs.addEventListener('touchstart', handleTouchStart);
        tabs.addEventListener('touchend', handleTouchEnd);
        tabs.addEventListener('touchmove', handleTouchMove);
    }

    function initializeTabs(tabButtons, tabContents) {
        if (tabButtons.length > 0 && tabContents.length > 0) {
            tabButtons[0].classList.add(TAB_BUTTON_ACTIVE_CLASS);
            tabContents[0].classList.add(TAB_CONTENT_ACTIVE_CLASS);

            tabButtons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    tabButtons.forEach((btn) => {
                        btn.setAttribute('aria-selected', 'false');
                        btn.classList.remove(TAB_BUTTON_ACTIVE_CLASS);
                    });

                    button.classList.add(TAB_BUTTON_ACTIVE_CLASS);
                    button.setAttribute('aria-selected', 'true');

                    tabContents.forEach((content) =>
                        content.classList.remove(TAB_CONTENT_ACTIVE_CLASS)
                    );
                    tabContents[index].classList.add(TAB_CONTENT_ACTIVE_CLASS);
                });
            });
        }
    }

    const tabGroups = document.querySelectorAll(TAB_GROUP_SELECTOR);

    tabGroups.forEach((tabGroup) => {
        const tabListNav = tabGroup.querySelector('.tab-list__nav-rsev');
        const TAB_CONTENTS =
            tabGroup.parentNode.querySelectorAll('.tab__content-rsev');
        const TAB_BUTTONS = tabGroup.querySelectorAll('.tab__button-rsev');

        if (TAB_CONTENTS.length > 0 && TAB_BUTTONS.length > 0) {
            if (isSmallerDevice()) {
                addHorizontalScroll(
                    tabGroup,
                    tabListNav,
                    TAB_CONTENTS,
                    TAB_BUTTONS
                );
                checkBorder(tabListNav, TAB_CONTENTS, TAB_BUTTONS);
            }

            initializeTabs(TAB_BUTTONS, TAB_CONTENTS);

            window.addEventListener('resize', () => {
                if (isSmallerDevice()) {
                    addHorizontalScroll(
                        tabGroup,
                        tabListNav,
                        TAB_CONTENTS,
                        TAB_BUTTONS
                    );
                    checkBorder(tabListNav, TAB_CONTENTS, TAB_BUTTONS);
                } else {
                    tabListNav.style.borderRight = 'none';
                }
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    _customTabGroup();
});
